
import { Container, Row, Nav, Stack, Accordion } from 'react-bootstrap';
import { Link } from '@mui/material';
import React from 'react';
import { Dimensions } from 'react-native';

import { Carousel } from 'react-responsive-carousel';
import InstagramIcon from '@mui/icons-material/Instagram';
const WispyPage = ({ urlSearchParameters, lang, linkId, text, leftLinkId, leftLinkText, rightLinkId, rightLinkText, likes, comments, onLikesUpdated, onCommentsUpdated }) => {
    let isLarge = true
    let width = '600px'
    const widthSmall = '400px'
    const windowDimensions = Dimensions.get('window');
    if (windowDimensions.width < 800) {
        isLarge = false
        width = '90%'
    }

    return (
        <>
            <Container style={{ height: '100%' }}>
                <br />
                <h3>
                    A Cloud Called Wispy
                </h3>
                <figure>
                                        <img src="../wispy/wispy.jpg"
                                            style={{ display: 'block', margin: 'auto', width:  windowDimensions.width < 800? width: widthSmall }} />
                                        <figcaption style={{ 'text-align': 'center' }} ><i>Wispy
                                        </i></figcaption>
                                    </figure>
<h4>Where Wispy Came From</h4>
                <p>
                
Wispy was born on a quiet afternoon, lying on a blanket with my twin boys, watching clouds drift across the sky. We spotted crocodiles, elephants, dragons — until I saw one that looked just like them.

That cloud became Wispy — curious and cheeky like one twin, gentle and thoughtful like the other. I made up story after story for them as toddlers, and for a while, Wispy became part of our sky.

Then life rushed in, and Wispy floated off for nearly 12 years… until now.

These stories are my way of bringing him back — and sending him out into the world, one little wander at a time.

                </p>
            
                        Wispy early artwork
                        <a href="https://photos.app.goo.gl/rrDZTXkpYvifg8qG9" target="_blank"> here</a>

                <Row className="justify-content-between">

                </Row>
            </Container>
        </>
    )
};



// const WispyPage = ({ urlSearchParameters, lang, linkId, text, leftLinkId, leftLinkText, rightLinkId, rightLinkText, likes, comments, onLikesUpdated, onCommentsUpdated }) => {

//     return (
//         <>
//             <Container>
//                 <br/>
//                 <br/>
//                 Recipe 1
//                 ...
//                 Recipe 2
//                 ...
//             </Container>
//         </>
//     )
// }


export default WispyPage;